// src/App.tsx
import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import HomePage from "./pages/HomePage";
import LoginPage from "./pages/LoginPage";
import DashboardPage from "./pages/Dashboard";
import KeysPage from "./pages/Keys";
import UsagesPage from "./pages/Usages";
import DocsPage from "./pages/Docs";
import SubscriptionsPage from "./pages/Subscriptions";
import AccountPage from "./pages/Settings/SettingsPage";
import { AuthProvider } from "./contexts/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Layout from "./components/Layout";
import RegisterPage from "./pages/RegisterPage";
import UnProtectedRoute from "./components/UnprotectRoute";
import { APIProvider } from "@vis.gl/react-google-maps";
import { UserProvider } from "./contexts/UserContext";
import ValuationPage from "./pages/Valuation/ValuationPage";
import DescriptionPage from "./pages/Description";
import AuctionRecordsPage from "./pages/AuctionRecords/AuctionRecordsPageV2";
import MarketDashboardPage from "./pages/MarketDashboard/MarketDashboardPage";
import ArtistDetailPage from "./pages/ArtistDetail/ArtistDetailPage";
import AuctionRecordDetailPage from "./pages/AuctionRecordDetail/AuctionRecordDetailPage";
import EmergingArtistsPage from "./pages/EmergingArtists/EmergingArtistsPage";
import AuctionHousesIndex from "./pages/AuctionHouses/AuctionHousesIndex";
import AuctionHouseDetail from "./pages/AuctionHouses/AuctionHouseDetail";

const App: React.FC = () => {
  return (
    <div className="antialiased text-zinc-950 lg:bg-zinc-100 dark:bg-zinc-900 dark:text-white dark:lg:bg-zinc-950">
      <AuthProvider>
        <Router>
          <Routes>
            <Route element={<UnProtectedRoute />}>
              <Route path="/" element={<HomePage />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/register" element={<RegisterPage />} />
            </Route>
            <Route
              path="*"
              element={
                <APIProvider
                  apiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY ?? ""}
                >
                  <UserProvider>
                    <Layout>
                      <ProtectedRoute>
                        <Routes>
                          <Route
                            path="/dashboard"
                            element={<DashboardPage />}
                          />
                          <Route path="/usages" element={<UsagesPage />} />
                          <Route path="/keys" element={<KeysPage />} />
                          <Route path="/docs" element={<DocsPage />} />
                          <Route
                            path="/valuation"
                            element={<ValuationPage />}
                          />
                          <Route
                            path="/description"
                            element={<DescriptionPage />}
                          />
                          <Route
                            path="/auctionRecords"
                            element={<AuctionRecordsPage />}
                          />
                          <Route
                            path="/market"
                            element={<MarketDashboardPage />}
                          />
                          <Route
                            path="/emerging-artists"
                            element={<EmergingArtistsPage />}
                          />
                          <Route
                            path="/auction-houses"
                            element={<AuctionHousesIndex />}
                          />
                          <Route
                            path="/auction-houses/:slug"
                            element={<AuctionHouseDetail />}
                          />
                          <Route
                            path="/artist/:id"
                            element={<ArtistDetailPage />}
                          />
                          <Route
                            path="/auction-record/:id"
                            element={<AuctionRecordDetailPage />}
                          />
                          <Route
                            path="/subscriptions"
                            element={<SubscriptionsPage />}
                          />
                          <Route path="/settings/*" element={<AccountPage />} />
                          <Route path="*" element={<HomePage />} />
                        </Routes>
                      </ProtectedRoute>
                    </Layout>
                  </UserProvider>
                </APIProvider>
              }
            />
          </Routes>
        </Router>
      </AuthProvider>
    </div>
  );
};

export default App;
